<template>
    <div class="saveOrUpdateCrud margin-10-10-0">
        <div>
            <el-page-header @back="close" content="审核学生信息"></el-page-header>
        </div>
        <el-form :model="upsertForm" :inline="true" label-width="100px" style="margin-top: 20px;" >
            <div style="border: dashed 1px #1989FA;height: 250px">
                <div style="height: 30px;">
                    <el-alert title="基础信息" type="success" :closable="false"></el-alert>
                </div>
                <div style="margin-top: 10px">
                    <div style="width: 25%;float: left">
                        <el-form-item label="照片">
                            <img v-if="upsertForm.faceImg" :src="config.resPre+upsertForm.faceImg" class="uploader-img">
                        </el-form-item>
                    </div>
                    <div style="width: 75%;float: left" class="longLabeles">
                        <el-form-item label="考生姓名">
                            <el-input size="mini" readonly v-model="upsertForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <el-input size="mini" readonly v-model="upsertForm.idCard" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="出生日期">
                            <el-input size="mini" readonly  v-model="upsertForm.birthday" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-input size="mini" readonly  v-model="upsertForm.sex" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="民族">
                            <el-input size="mini" readonly  v-model="upsertForm.nation" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌">
                            <el-input size="mini" readonly  v-model="upsertForm.politicalAffiliation" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="家庭住址" prop="homeAddress">
                            <el-input size="mini" readonly maxlength="50"  placeholder="请输入家庭住址" show-word-limit  v-model="upsertForm.homeAddress" auto-complete="off"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div style="border: dashed 1px #1989FA;height: 140px;margin-top: 10px" class="phoneLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="联系电话" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="联系电话">
                    <el-input size="mini" readonly v-model="upsertForm.phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮编">
                    <el-input size="mini" readonly v-model="upsertForm.adressCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系地址">
                    <el-input size="mini" readonly  style="width: 410px" v-model="upsertForm.address" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="紧急联系人" prop="emergencyContact">
                    <el-input size="mini" readonly  v-model="upsertForm.emergencyContact" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="紧急联系人方式" prop="emergencyPhone">
                    <el-input size="mini" readonly  v-model="upsertForm.emergencyPhone" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: auto;margin-top: 10px" class="longLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="报考情况" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="毕业学校">
                    <el-input size="mini" readonly v-model="upsertForm.univerColleges" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业学校代码">
                    <el-input size="mini" readonly v-model="upsertForm.unicerCollegesCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考院校">
                    <el-input size="mini" readonly v-model="upsertForm.studyColleges" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考院校代码">
                    <el-input size="mini" readonly v-model="upsertForm.studyCollegesCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业专业">
                    <el-input size="mini" readonly v-model="upsertForm.studyMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业证书编号">
                    <el-input size="mini" readonly  v-model="upsertForm.endSchoolCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考专业">
                    <el-input size="mini" readonly  v-model="upsertForm.examMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="考生类型" prop="studentType">
                    <el-input size="mini" readonly  v-model="upsertForm.studentType" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="建档立卡所在省" prop="archivesCardProvince" v-if="upsertForm.studentType && upsertForm.studentType=='建档立卡'">
                    <el-input size="mini" readonly  v-model="upsertForm.archivesCardProvince" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍时间" prop="joinArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入入伍时间"  show-word-limit  v-model="upsertForm.joinArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役时间" prop="endArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入退役时间"  show-word-limit  v-model="upsertForm.endArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役安置地" prop="endArmyAdress" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="255" placeholder="请输入退役安置地"  show-word-limit  v-model="upsertForm.endArmyAdress" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: 200px;margin-top: 10px" class="longLabels">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="其它信息" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="所获奖励">
                    <el-input size="mini" readonly type="textarea" autosize resize="none" style="width: 1000px" v-model="upsertForm.reward" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="特长">
                    <el-input size="mini"readonly type="textarea" autosize resize="none" style="width: 1000px" v-model="upsertForm.speciality" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input size="mini" readonly type="textarea" autosize resize="none" style="width: 1000px" v-model="upsertForm.remark" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;margin-top: 10px" class="longLabel longLabeldo">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="资格审核文件" type="success" :closable="false"></el-alert>
                </div>
              <div>
                <el-form-item label="    "  :prop="'sysUploadFileItems.' + index + '.url'" :rules="{required: true, message: '请上传'+item.fileName}"  v-for="(item,index) in upsertForm.sysUploadFileItems">
                  <el-image v-if="item.url && !isPdfFile(item.url)" :src="config.resPre+item.url" class="avatarImg" :preview-src-list="[config.resPre+item.url]"></el-image>
                  <!-- PDF预览卡片（强制完全居中） -->
                  <div v-else-if="item.url && isPdfFile(item.url)" style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 0; padding: 0;">
                    <i class="el-icon-file-pdf" style="font-size: 60px; color: #e53935; margin-bottom: 10px;"></i>
                    <div style="font-size: 16px; color: #333; margin-bottom: 15px; text-align: center; width: 100%;">
                      {{ item.fileName }}上传成功
                    </div>
                    <button
                      @click.stop="previewPdf(item.url)"
                      style="padding: 6px 20px; background: #409EFF; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
                      点击预览
                    </button>
                  </div>
                  <div style="text-align: center;width:450px;font-size:12px">
                    {{item.fileName}}
                  </div>
                </el-form-item>
              </div>
            </div>
            <div style="border: dashed 1px #1989FA;height: 200px;margin-top: 10px" class="longLabels">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="审核" type="error" :closable="false"></el-alert>
                </div>
                <el-form-item label="审核备注" prop="examineRemark">
                    <el-input size="mini" placeholder="请输入审核备注" type="textarea" autosize resize="none" style="width: 1000px" v-model="upsertForm.examineRemark" auto-complete="off"></el-input>
                </el-form-item>
                <div class="dialog-footer" style="text-align: right;margin: 10px 30px 20px 0px">
                    <el-button plain class="large" size="mini" @click="close">取 消</el-button>
                    <el-button plain size="mini" type="success"  @click="onSubmit('1','审核通过')">审核通过</el-button>
                    <el-button plain size="mini" type="danger" @click="onSubmit('2','审核不通过')">审核不通过</el-button>
                </div>
            </div>
        </el-form>

    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "lookSysStudent",
        props: ['id'],
        data(){
            return {
                defaultImg:require('../../../assets/frame/images/emp_icon.png'),
                pdfDeaultUrl:require('../../../assets/pdf.png'),
                upsertForm:{
                    id:'',
                    sequence:'',
                    studentId:'',
                    name:'',
                    idCard:'',
                    birthday:'',
                    sex:'',
                    nation:'',
                    politicalAffiliation:'',
                    faceImg:'',
                    phone:'',
                    adressCode:'',
                    studentType:'',
                    address:'',
                    ticketNumber:'',
                    password:'',
                    univerColleges:'',
                    unicerCollegesCode:'',
                    studyColleges:'',
                    studyCollegesCode:'',
                    studyMajor:'',
                    examMajor:'',
                    studyCode:'',
                    reward:'',
                    speciality:'',
                    remark:'',
                    studySequence:'',
                    status:'',
                    examineName:'',
                    examineTime:'',
                    examineRemark:'',
                    updateTime:'',
                    createTime:''
                },
                onSubmitForm:{
                    id:'',
                    examineRemark:'',
                    status:'',
                },
                config:config,
                imgForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    studentId:'',
                    year:'',
                    payImg:'',
                    idCardPositiveImg:'',
                    idCardSideImg:'',
                    scoreImg:'',
                    scoreType:'',
                    studentProofImg:'',
                    schoolReportImg:'',
                    diplomaImg:'',
                    otherImg:'',
                    status:'',
                    reason:'',
                    updateTime:'',
                    createTime:''
                },
            }
        },
        created(){
            axios({
              url:`${home}/sysStudent/lookSysStudentByIds/${this.id}`,
              method:'GET'
            }).then(res=>{
              Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
              console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            getExamInfo(){
                axios({
                    url:`${home}/sysStudentExam/getMyInfoExamById/${this.id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.imgForm,res.data);
                }).catch(error=>{

                })
            },
            close(){
                this.$emit('closeLookSysStudent');
            },
            onSubmit(status,handel){
                this.$confirm("确认对该学员"+handel+"吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.onSubmitForm.status = status;
                    this.onSubmitForm.examineRemark = this.upsertForm.examineRemark;
                    this.onSubmitForm.id = this.upsertForm.id;
                    axios({
                        url: `${home}/sysStudent/onSubmit`,
                        method: 'POST',
                        data: this.onSubmitForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.close();
                    }).catch(error => {
                        console.log(error);
                    })
                });
            },
          isPdfFile(url) {
            if (!url) return false;
            return url.toLowerCase().endsWith('.pdf');
          },
          // 预览PDF
          previewPdf(url) {
            window.open(this.config.resPre + url, '_blank');
          },
        }
    }
</script>

<style scoped lang="scss">
    .look{
        width:60%;
        margin: 20px 0 0 10px;
    }

</style>
<style lang="scss">
    .longLabeles{
        .el-input__inner{
            width: 320px;
        }
    }
    .longLabeldo{
        .el-form-item {
            display: inline-block;
            margin-right: 0px !important;
            vertical-align: top;
        }
    }
    .longLabel{
        .el-form-item__label{
            width: 110px !important;
        }
        .el-input__inner{
            width: 265px;
        }
    }
    .longLabels{
        .el-form-item__label{
            width: 140px !important;
        }
    }
    .phoneLabel{
        .el-form-item__label{
            width: 120px !important;
        }
    }
    .avatarImg{
        width: 455px;
        height: 200px;
        display: block;
        padding: 0px;
    }
</style>
